import React, { type FC } from 'react';
import type { AfterCartItemGroupComponentProps } from '@kidslabs/module-quote';
import { GiftsOfProductInCart } from '@kidslabs/module-flash-sale';

/**
 * AfterCartItemGroupComponent for Nova cart
 * Renders GiftsOfProductInCart component after each cart item group (product)
 * This follows the same pattern as mobile hermes: `AfterCartItemGroupComponent`
 *
 * @see mobile-ecommerce/applications/module-theme-hermes/src/modules/quote/components/after-cart-item-group-component/after-cart-item-group-component.tsx
 */
export const AfterCartItemGroupComponent: FC<AfterCartItemGroupComponentProps> = props => {
    const { disabled, variant, cartItemReference, className, size, showActionButton } = props;

    return (
        <GiftsOfProductInCart
            variant={variant}
            disabled={disabled}
            data={cartItemReference}
            className={className}
            size={size}
            showActionButton={showActionButton}
        />
    );
};

export default AfterCartItemGroupComponent;
